import { Button, Card, fontStyles, Icon } from '@monash/portal-react';
import c from './service-form.module.scss';
import cs from '../../service-page.module.scss';
import classNames from 'classnames';
import ConsentDisclaimer from './consent-disclaimer/ConsentDisclaimer';
import ApplicationDetails from './application-details/ApplicationDetails';
import { FormProvider, useForm } from 'react-hook-form';
import InfoHeader from '../info-header/InfoHeader';

const ServiceForm = ({ name, description, externalLink }) => {
  const methods = useForm({
    mode: 'onChange',
    reValidateMode: 'onBlur',
    defaultValues: {
      units: [],
      startDate: null,
      discoveryMethods: [],
      additionalInfo: '',
    },
  });

  const {
    handleSubmit,
    formState: { isValid },
  } = methods;

  const onSubmit = async (data) => {
    console.debug('Submitted');
    console.debug(data);
  };

  return (
    <Card className={c.cardContainer}>
      <div className={classNames(cs.alert, c.eligible)}>
        <Icon.CircleCheck />
        <div className={cs.alertTextContainer}>
          <div className={classNames(fontStyles.heading, fontStyles.sm)}>
            Good news, you are eligible!
          </div>
          <div>
            Based on your student profile, you are eligible to apply for this
            program.
          </div>
        </div>
      </div>
      <FormProvider {...methods}>
        <form
          className={c.formContainer}
          onSubmit={handleSubmit(async (data) => await onSubmit(data))}
        >
          <div className={c.formContent}>
            <div className={c.formFieldsContainer}>
              <InfoHeader
                name={name}
                description={description}
                externalLink={externalLink}
              />
              <ApplicationDetails />
            </div>
            <div inert className={c.verticalSeparator} />
            <ConsentDisclaimer />
          </div>
          <Button className={c.submitButton} type="submit" disabled={!isValid}>
            Agree and Submit Application
          </Button>
        </form>
      </FormProvider>
    </Card>
  );
};

export default ServiceForm;
